import { ColorPickerField } from '../../components/ColorPickerField';
import { IconField } from '../../components/IconField';
import Pyramid from './Pyramid';

const pyramidPlugin: any = {
  Renderer: ({ data }: any) => <Pyramid fields={data.fields} />,
  id: 'pyramid',
  title: 'Pyramid',
  description: 'Pyramid with configurable elements',
  version: 1,
  controls: {
    type: 'autoform',
    columnCount: 1,
    schema: {
      properties: {
        // recipientId: {
        //   type: 'string',
        //   enum: ['recipient-1', 'recipient-2', 'recipient-3'],
        // },
        fields: {
          type: 'array',
          items: {
            type: 'object',
            properties: {
              documentLinkIcon: {
                type: 'string',
                default: '',
              },
              documentLinkTitle: {
                type: 'string',
                default: '',
              },
              sectionBackground: {
                type: 'string',
                default: 'rgba(204,204,204,1)',
                uniforms: {
                  component: ColorPickerField,
                  label: 'Background: ',
                },
              },
              title: {
                type: 'string',
                default: 'Title',
              },
              titleColor: {
                type: 'string',
                default: 'rgba(255,255,255,1)',
                uniforms: {
                  component: ColorPickerField,
                  label: 'Title Color: ',
                },
              },
              icon: {
                type: 'string',
                default: 'Anchor 2',
                uniforms: {
                  component: IconField,
                  label: 'Icon: ',
                },
              },
              iconColor: {
                type: 'string',
                default: 'rgba(255,255,255,1)',
                uniforms: {
                  component: ColorPickerField,
                  label: 'Icon color: (*where applicable) ',
                },
              },
              description: {
                type: 'string',
                default: 'Description',
              },
            },
          },
        },
      },
      required: ['fields'],
    },
  },
};
export default pyramidPlugin;
